import { findIndex } from 'lodash';
import { SpeakToTextDto } from 'types';
import { MessagePosition, SpeakToTextPosition } from 'types/message-position.type';

export const calculateStartEndPositionMessage = (
  { scrollTop, clientHeight }: { scrollTop: number; clientHeight: number },
  messagePositions: MessagePosition[]
) => {
  const viewportStart = scrollTop;
  const viewportEnd = scrollTop + clientHeight;

  const startIndex = findIndex(messagePositions, (o) => o.position + o.height >= viewportStart - 300);
  const endIndex = findIndex(messagePositions, (o) => o.position >= viewportEnd + 300);
  return {
    start: startIndex === -1 ? 0 : startIndex,
    end: endIndex === -1 ? messagePositions.length : endIndex
  };
};

export const calculateStartEndPositionSpeakToText = (
  { scrollTop, clientHeight }: { scrollTop: number; clientHeight: number },
  messagePositions: SpeakToTextPosition[]
) => {
  const viewportStart = scrollTop;
  const viewportEnd = scrollTop + clientHeight;

  const startIndex = findIndex(messagePositions, (o) => o.position + o.height >= viewportStart - 300);
  const endIndex = findIndex(messagePositions, (o) => o.position >= viewportEnd + 300);
  return {
    start: startIndex === -1 ? 0 : startIndex,
    end: endIndex === -1 ? messagePositions.length : endIndex
  };
};
